/* eslint-disable react/button-has-type */
import * as React from 'react';

import { FlameTheme } from '@lightspeed/flame/Core';
import { get } from 'lodash';

import Decimal from 'app/src/data/base/Decimal';
import Format from 'app/src/data/Format';
import { translate } from 'pages/utils/translate';

import { ICreditDebitPayments } from './PaymentCreditDebitRefundByRefView';

export interface IViewData {
  currencySymbol: string;
  allowCredits: boolean;
  outstandingBalance: Decimal;
  creditDebitPayments: Array<ICreditDebitPayments>;
}
export const PaymentCreditDebitRefund = ({ viewData }: { viewData: IViewData }) => {
  const cardInformation = (payment: ICreditDebitPayments) => {
    const cardBrand = get(payment, 'details.cardBrand');
    const cardType = get(payment, 'details.cardType');

    const card = cardBrand || cardType || translate('Unknown');

    let cardInformation = '';
    if (payment.details) {
      cardInformation = `${payment.details.transactionDate}\n${card} ●●●${payment.details.maskedDigits}`;
    } else if (payment.model.CCCharge) {
      const transactionDate = payment.model.createTime.split('T')[0];
      cardInformation = `${transactionDate}\n${card} ●●●${payment.model.CCCharge.xnum}`;
    }
    return cardInformation;
  };

  return (
    <FlameTheme>
      {translate('Refund An Existing Charge')}
      <table className="refunds_list" cellPadding="0" cellSpacing="0">
        <tbody>
          <tr>
            <td />
          </tr>
          {viewData.creditDebitPayments.map(payment => {
            return (
              <tr
                key={payment.model.salePaymentID}
                aria-label={`${payment.model.salePaymentID} - payment`}
              >
                <th className="credit-debit-refund-list-item">
                  <div aria-label="cardInformation">{cardInformation(payment)}</div>
                </th>
                <td>
                  <div
                    className="money-field-container payment-block-money"
                    currency-symbol={viewData.currencySymbol}
                  >
                    <input
                      type="text"
                      className="money group group-start"
                      disabled
                      size={9}
                      aria-label="refund amount input"
                      value={Format.formatMoney(
                        Decimal.min(
                          viewData.outstandingBalance.abs(),
                          payment.maximumRefundAmount
                        ).abs(),
                        0,
                        false
                      )}
                    />
                  </div>
                  <button
                    data-payment-id={payment.model.salePaymentID}
                    aria-label="refund button"
                    className="group group-end refund-button gui-def-button"
                  >
                    {translate('Refund')}
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>

      <table className="refunds_list" cellPadding="0" cellSpacing="0">
        <tbody>
          {viewData.allowCredits && (
            <tr>
              <td>
                {translate('Or ')}
                <button id="creditRefundOnNewCard" className="gui-def-button">
                  {translate('Refund On New Card')}
                </button>
              </td>
            </tr>
          )}
          <tr>
            <td>
              <button id="creditRefundCancel" aria-label="refund cancel" className="gui-def-button">
                {translate('Cancel')}
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </FlameTheme>
  );
};
